import { Col, Container, Row } from '@geberit/gdds';
import key from 'weak-key';

// components
import { LinksBlock } from './links-block';
import { SearchIndexOff } from 'components/SearchIndex/SearchIndexOff';

// styles
import styles from './related-links.module.scss';

// utils
import { isEmpty } from 'utils/is-empty';
import { generateSlug } from 'utils/slug';
import { buildSize, gridSizes } from 'utils/gridSize';
import { Headline } from 'components/ContentElementsGdds/headline/headline';

export function RelatedLinks({
  title = '',
  anchor = '',
  categories = [],
}: Readonly<RelatedLinksProps>) {
  if (isEmpty(title) || isEmpty(categories)) {
    return null;
  }

  return (
    <SearchIndexOff>
      <section className={styles.pageLinks} id={generateSlug(anchor ?? title ?? '')}>
        <Container maxContentWidth={buildSize(gridSizes.gddsFullGrid)}>
          <Row>
            <Col size={[4, 8, 3]}>
              <Headline tag="h3" title={title} className={styles.headline} />
            </Col>
            <Col size={[4, 8, 9]}>
              <div className={styles.blocks}>
                {categories?.map((items) => <LinksBlock linkBlock={items} key={key(items)} />)}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </SearchIndexOff>
  );
}
